module.exports = __webpack_public_path__ + "img/goUP.2b49eeb0.svg";